import { computeMinutesUntilStart, formatDateTime, formatMaintenanceCountdown } from './maintenanceBlock';

export const UPCOMING_WARNING_THRESHOLDS_MINUTES = [120, 60, 30, 15, 5, 1];

const STORAGE_PREFIX = 'clientMaintenanceWarnShown';

function storageKey(maintenanceId, thresholdMinutes) {
  return `${STORAGE_PREFIX}:${maintenanceId}:${thresholdMinutes}`;
}

export function hasShownUpcomingWarning(maintenanceId, thresholdMinutes) {
  if (!maintenanceId || !thresholdMinutes) return false;
  try {
    return localStorage.getItem(storageKey(maintenanceId, thresholdMinutes)) === '1';
  } catch (_e) {
    return false;
  }
}

export function markUpcomingWarningShown(maintenanceId, thresholdMinutes) {
  if (!maintenanceId || !thresholdMinutes) return;
  try {
    UPCOMING_WARNING_THRESHOLDS_MINUTES
      .filter((threshold) => threshold >= thresholdMinutes)
      .forEach((threshold) => {
        localStorage.setItem(storageKey(maintenanceId, threshold), '1');
      });
  } catch (_e) {
    // ignore storage errors
  }
}

export function getNextDueUpcomingWarning(maintenance) {
  if (!maintenance?.id) return null;

  const minutesUntilStart = computeMinutesUntilStart(maintenance);
  if (minutesUntilStart == null || !Number.isFinite(minutesUntilStart)) return null;

  const thresholdMinutes = UPCOMING_WARNING_THRESHOLDS_MINUTES
    .filter(
      (threshold) =>
        minutesUntilStart <= threshold
        && !hasShownUpcomingWarning(maintenance.id, threshold)
    )
    .sort((a, b) => a - b)[0];

  if (thresholdMinutes == null) return null;

  return {
    maintenance,
    thresholdMinutes,
    minutesUntilStart,
    leadTimeLabel: formatMaintenanceCountdown(thresholdMinutes),
    startsAtLabel: formatDateTime(maintenance.start_utc),
  };
}

export function getUpcomingWarningPollIntervalMs(minutesUntilStart) {
  if (minutesUntilStart == null || !Number.isFinite(minutesUntilStart)) return 60000;
  if (minutesUntilStart <= 15) return 15000;
  if (minutesUntilStart <= 130) return 30000;
  return 60000;
}

export function getScheduledListFromResponse(response) {
  if (!response) return [];
  if (Array.isArray(response.scheduled)) return response.scheduled;
  if (Array.isArray(response)) return response;
  return [];
}

export function pickNearestUpcomingMaintenance(scheduledResponse) {
  const list = getScheduledListFromResponse(scheduledResponse);
  return list.find((item) => item?.id && item?.start_utc) || null;
}
